// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2zbFS","title":"BackImages_title__36Bi0","images":"BackImages_images__PDsWP"};